
/**
 * Performs a blog search
 * @param e - keypressed event
 */
 const handleSearch = (e: any) => {
    if (e.key === 'Enter' || e.which === 13) {
        window.open(`/?s=${encodeURI(e.target?.value || '')}`, '_self');
        return false;
    }
};


export {
    handleSearch,
};
